/*
 * @Author       : yiyang
 * @Date         : 2020-06-10 16:31:57
 * @LastEditors  : Please set LastEditors
 * @LastEditTime : 2020-11-12 18:19:09
 * @PRD          : 
 * @Description  : 
 * @FilePath     : /work/yit_fe_shangbo/src/layouts/HomeLayout.js
 * @URL          : 
 */
import './HomeLayout.css'
import React, { useEffect } from 'react'
import NETImage from 'components/net-image'

/**
 * 首页布局
 */
export default function Homelayout({ children }) {
    useEffect(() => {
        document.title = '上海博物馆播客'
    })

    return (
        <section className='home__layout'>
            <NETImage
                src='classifyList/bk/banner.jpg?t=1'
                useAutoHeight
                startHeight={120}
            />
            <div className='home__layout-content--wrapper'>
                <div className='home__layout-content'>
                    {children}
                </div>
            </div>
            <div className='home__layout-bottom'>
                <span>上海博物馆</span>
            </div>
        </section>
    )
}